module.exports = __webpack_public_path__ + "img/iconMode.187892d0.svg";